function DecadeBorn({ isOpen, onClose, aboutMe, setAboutMe, onSave }) {
  if (!isOpen) return null; // Don't render if modal is closed
 
  return (
	<div className="modal fade all_sm_modalss show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1050, }} >
	 <div className="modal-dialog modal-dialog-centered">
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">Decade you were born</h5>
				<p>Don’t worry, other people won’t be able to see your exact birthday.</p>
				<button type="button" className="btn-close" onClick="{onClose}"><i className="fa fa-times" ></i></button>
			</div>
			<div className="modal-body">
				fghfhfg
			</div>
			<div className="modal-footer">
				<button type="button" className="btn btn-primary" onClick="{onSave}">
					Save
				</button>
			</div>
		</div>
	 </div>
	</div>
  );
}
 
export default DecadeBorn;